import React from 'react';
import fakeAuth from '../../fakeAuth';
import moment from 'moment';
import config from '../../config';
import _ from 'lodash';
import { formatPriceWithoutCurrency, padWithZeros, stripHTMLTags } from '../../helpers';

class PrintableClose extends React.Component {

    state = {
        hotel_name: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).Name : null,
        IdProperty: localStorage.getItem('lb.ip') ? JSON.parse(localStorage.getItem('lb.ip')).IdProperty : null,
    }

    // Lifecycle
    componentWillMount() {
        const { params } = this.props, { id, day } = params;
        if (id) {
            let me = fakeAuth.getUser();
            // This is the Id of the property, but in order to get the super-users, 
            // we must find the IdAccount
            this.props.staffs_actions && this.props.staffs_actions.fetch(me.IdAccount);
            this.setup();
        } else this.props.router.goBack();
    }
    componentWillReceiveProps = nextProps => {
        //const { book, bookings, booking_actions, property } = nextProps, { id } = this.props.params;
        //if (book && book.IdBook) this.setState({ book }, () => {
        // NEW: here we need to get the 'occupancy of pieces of the day the reservation starts (or today if that day has already passed). 
        // Then we use that occupancy to rule out pieces for assigning due to -well- they are taken                    
        if (!this.state.bootstrapped &&
            nextProps.report_entries?.length > 0 &&
            nextProps.staffs?.length > 0
        ) {
            this.setState({ bootstrapped: true }, () => {                
                setTimeout(() => window?.print(), 1000);
            });
        }
        //});
    }
    //

    setup = () => {
        const { params } = this.props, { id, day } = params;
        this.props.logic_actions && this.props.logic_actions.fecth_close_report({
            IdProperty: id,
            Day: day
        });
    }

    componentDidMount = () => {
        //
    }
    render() {
        const { payment_types } = config;
        const { staffs } = this.props;
        const { report_entries } = this.props;
        let filtered_report = _.chain(report_entries)
            .filter(u => parseInt(u.Credit))
            .filter(u => u.IdUser === this.props.params.idUser)
            .value();

        //width: 8.5in; height:11.0in
        let user = _.chain(staffs).find(u => u.IdUser === this.props.params.idUser).value();
        return (!user || !filtered_report.length) ? <></> : <section className="sheet margin-top p-4 font-10" style={{ borderRadius: 2, width: 'fit-content', minWidth: '8.5in', minHeight: '11.0in', margin: 'auto' }}>
            <h3 className="ms-auto align-self-center">{this.state.hotel_name}</h3>
            <div className="d-flex mt-2">
                <span className="toBold">Empleado: <i className="toBold">{`${user.FirstName} ${user.LastName}`}</i></span>
                <span className="ms-auto">Fecha: {moment(_.first(filtered_report).CreateDate).format('DD/MM/YYYY')}</span>
            </div>
            <div className="d-flex">
                <span>Cargo: {`${user.JobTitle || 'Admin'}`}</span>
            </div>
            <h4 className="text-center">Reporte de cierre de actividad</h4>
            <table className="table table-sm font-8">
                <thead>
                    <tr>
                        <th>Recibo</th>
                        <th>Id</th>
                        <th>Cliente</th>
                        <th>Concepto</th>
                        <th>Forma de pago</th>
                        <th>Divisa</th>
                        <th className="text-right">Monto</th>
                    </tr>
                </thead>
                <tbody>
                    {filtered_report.map((t, i) => {
                        t.PaymentType = parseFloat(t.Credit) ? (_.find(payment_types, pt => pt.id === t.IdPaymentType) || _.first(payment_types)).name : '-';
                        return (<tr key={i}>
                            <td>{t.Confirmation}</td>
                            <td>{t.IdBookAccounting.slice(-8)}</td>
                            <td>{t.GivenName}</td>
                            <td>{t.Reason}</td>
                            <td>{t.PaymentType}</td>
                            <td>USD</td>
                            <td className="text-right">{formatPriceWithoutCurrency((parseFloat(t.Debit) || parseFloat(t.Credit)) * 100)}</td>
                        </tr>)
                    })}
                </tbody>
            </table>
        </section>
    }
}
export default PrintableClose;